import styled from "styled-components";

export const NumberOfResultsDefaultBox = styled.span`
      margin: 0 0 0 1rem;
      color: ${props => props.theme.colors.brandPrimary};
      font-size: 1.5rem;
`;